import { render, staticRenderFns } from "./TreeView.vue?vue&type=template&id=65b9d4c9&scoped=true"
import script from "./TreeView.vue?vue&type=script&lang=js"
export * from "./TreeView.vue?vue&type=script&lang=js"
import style0 from "./TreeView.vue?vue&type=style&index=0&id=65b9d4c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b9d4c9",
  null
  
)

export default component.exports